<template>
    <div class="h-[70px] flex justify-center p-5">
        <div class="">
            <img :src="asset('img/logo-black.png')" height="180" width="180" />
        </div>
    </div>
</template>
